import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserProfile } from '@/lib/api';
import type { Profile } from '@/types/database.types';
import UserProfileCard from '@/components/profile/UserProfileCard';
import { useAuth } from '@/context/AuthContext';

export default function UserProfile() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!id) return;
      try {
        setLoading(true);
        const data = await getUserProfile(id);
        setProfile(data);
      } catch (error) {
        console.error('Error fetching profile:', error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-900">User not found</h2>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <UserProfileCard
        profile={profile}
        showFollowButton={user?.id !== profile.id}
        onFollowChange={() => {
          // Refresh profile to get updated follow status
          getUserProfile(profile.id).then(setProfile);
        }}
      />
    </div>
  );
}